module.exports = __webpack_public_path__ + "static/media/santuarioVirgenCoromoto-small.a040485d.jpg";